module.exports = __webpack_public_path__ + "static/media/nps_report_icon.0291753c.svg";